import { styled } from 'next-yak';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXL } from '@xing-com/tokens';

export const ProductCardContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spaceXL};
  padding-top: ${spaceXL};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaSmallOrTiny} {
    flex-direction: column;

    & > [data-product-card='basic'] {
      display: none;
    }
  }
`;
